import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const EditEntry = React.lazy(() => import("@kaltura/mediaspace-features-edit-entry"));

export const InfoLine = React.lazy(() => import("@kaltura/mediaspace-features-edit-entry/info/info-line"));
export const PublishInfoLine = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/info/publish-info-line")
);

export const GenericTab = React.lazy(() => import("@kaltura/mediaspace-features-edit-entry/generic-tab/GenericTab"));

export const DetailsTab = React.lazy(() => import("@kaltura/mediaspace-features-edit-entry/details-tab/details-tab"));

export const ThemingTab = React.lazy(() => import("@kaltura/mediaspace-features-edit-entry/theming-tab/theming-tab"));

export const ThumbnailsTab = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/thumbnails-tab/thumbnails-tab")
);

export const SchedulingTab = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/scheduling-tab/scheduling-tab")
);

export const PublishingSchedule = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/scheduling-tab/components/PublishingSchedule")
);

export const ForcedPublishingSchedule = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/scheduling-tab/components/ForcedPublishingSchedule")
);

export const AdvanceEntranceTime = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/scheduling-tab/components/AdvanceEntranceTime")
);

export const WebcastResources = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/scheduling-tab/components/Resources")
);

export const WebcastCalendarReminder = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/scheduling-tab/components/CalendarReminder")
);

export const PrivacyTab = React.lazy(() => import("@kaltura/mediaspace-features-edit-entry/privacy-tab/PrivacyTab"));

export const RolesAndPermissionsTab = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/roles-and-permissions-tab/RolesAndPermissionsTab")
);

export const ReplaceMediaSection = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/assets-tab/replace/replace-section")
);

export const DownloadableAssetsSection = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/assets-tab/downloadmedia/downloadable-assets")
);

export const DownloadPermissionsSection = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/assets-tab/downloadmedia/download-permissions")
);

export const AttachmentsSection = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/assets-tab/attachments/attachments-section")
);

export const PreviewPlayer = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/preview-player/preview-player")
);

export const HiddenElements = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/preview-player/hidden-elements")
);

export const MediaPlayerFields = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/preview-player/media-player-fields")
);

export const ReachSection = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/accessibility-tab/ReachSection")
);

export const CaptionsSection = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/accessibility-tab/captions/CaptionsSection")
);

export const AudioTracksSection = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/accessibility-tab/audio-tracks/AudioTracksSection")
);

export const PreviewStreamSection = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/streaming-tab/PreviewStreamSection")
);

export const StreamDetailsSection = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/streaming-tab/stream-details/StreamDetailsSection")
);

export const StreamConfigurationSection = React.lazy(
    () =>
        import("@kaltura/mediaspace-features-edit-entry/streaming-tab/stream-configuration/StreamConfigurationSection")
);

export { LiveStudioTypeSelection } from "@kaltura/mediaspace-shared-edit-townhall";

export { RestreamDestinationsTabSection } from "@mediaspace/features/restream-destinations";

export const VideoSourceSection = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/streaming-tab/video-source/VideoSourceSectionContainer")
);

export const MeetingRoomTab = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/meeting-room-tab/MeetingRoomTab")
);

export const InteractionsTab = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/interactions-tab/InteractionsTab")
);

export const CommentsSection = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/comments-tab/CommentsSection")
);

export const LanguageTab = React.lazy(() => import("@kaltura/mediaspace-features-edit-entry/language-tab/LanguageTab"));

export const DisabledFieldLanguagesMessage = React.lazy(
    () => import("@kaltura/mediaspace-features-edit-entry/language-tab/DisabledFieldLanguagesMessage")
);

export const render = getDsLayoutComponentRenderer(EditEntry);
